<script setup>
import PageNotFound from '@/components/PageNotFound.vue';
</script>

<template>
  <PageNotFound />
</template>
